import {getService,postBodyService} from "./base.service";
import config from "../config/application";

//url
const list = 'account/list';
const add = 'account/add';
const update = 'account/update';
const deleteUrl = 'account/delete';

class AccountService {
    getAccounts(user,isPermitted,entity) {
        const url = `${config.data.income.account.url}${list}/${user}/${isPermitted}/${entity}`;
        return getService(url);
    }
    saveAccount(account){
        const url = `${config.data.income.account.url}${add}`;
        return postBodyService(url,account);
    }
    updateAccount(account){
        
        const url = `${config.data.income.account.url}${update}`;
        return postBodyService(url,account);
    }
    deleteAccount(lsaccount){
        const url = `${config.data.income.account.url}${deleteUrl}`;
        return postBodyService(url,lsaccount);
    }
    
}
export default new AccountService(); 